import permissionsMixin from "@/mixins/permissionsMixin.js";

export default {
  mixins: [permissionsMixin],
  methods: {
    dateDB(dateUser) {
      var dt = dateUser ? this.$moment(dateUser, "L") : null;
      return dt && dt.isValid() ? dt.format("YYYY-MM-DD HH:mm:ss") : null;
    },
    dateUser(dateDb) {
      var dt = dateDb ? this.$moment(dateDb, "YYYY-MM-DD HH:mm:ss") : null;
      return dt && dt.isValid() ? dt.format("L") : null;
    },
    eventOwner(dsecPartnerId) {
      return this.amazeUserCan('administer', 'dsec_calendar') || this.myPartners.indexOf(dsecPartnerId) >= 0
    },
    eventMethodString(methodChar) {
      if (methodChar) {
        switch (methodChar.toLowerCase()) {
          case 'i':
            return 'In-Person';
            // eslint-disable-next-line no-unreachable
            break;
          case 'v':
            return 'Virtual';
            // eslint-disable-next-line no-unreachable
            break;
          case 'h':
            return 'Hybrid';
            // eslint-disable-next-line no-unreachable
            break;
        }
      }
      return 'N/A';
    }
  },
  computed: {
    isPartner() {
      return this.$auth.user().dsec_partners.length > 0;
    },
    myPartners() {
      return this.$auth.user().dsec_partners.map(a => a.id);
    }
  }
}
